import { hot } from "react-hot-loader";
import { App } from "./components/App";

export default process.env.NODE_ENV !== "production" ? hot(module)(App) : App;
